import classNames from 'classnames';
import { FC, useState } from 'react';
import styles from './index.module.scss';

interface TextWithOpenIconProps {
  text: string;
  isOpen: boolean;
  onToggle: () => void;
  isTitle?: boolean;
}

export const TextWithOpenIcon: FC<TextWithOpenIconProps> = ({
  text,
  isOpen,
  isTitle,
  onToggle,
}) => {
  return (
    <div className={styles.textWithOpenIconWrapper} onClick={onToggle}>
      <div
        className={classNames(styles.textWithOpenIconText, {
          [styles.textWithOpenIconTitle]: isTitle,
        })}
      >
        {text}
      </div>
      <div
        className={classNames(styles.textWithOpenIconIcon, {
          [styles.textWithOpenIconIconOpen]: isOpen,
        })}
      />
    </div>
  );
};
